import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialRetweetIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialRetweet",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16.62 22.87H9.2V11.92h2.84c.48 0 .87-.39.87-.87 0-.27-.12-.51-.31-.66S8.09 5.88 8.09 5.88c-.16-.17-.39-.28-.64-.28s-.48.11-.64.28-4.51 4.5-4.51 4.5a.872.872 0 0 0 .56 1.54h2.85v12.7c0 .96.78 1.74 1.74 1.74h9.16a1.741 1.741 0 0 0 0-3.48Zm13.09-2.56a.88.88 0 0 0-.62-.26h-2.78V7.35c0-.96-.78-1.74-1.74-1.74h-9.16a1.741 1.741 0 0 0 0 3.48h7.42v10.93H20a.87.87 0 0 0-.87.87c0 .27.12.51.31.66s4.5 4.57 4.5 4.57c.16.17.39.28.64.28s.48-.11.64-.28 4.51-4.51 4.51-4.51a.861.861 0 0 0 .01-1.3Z"
    })
  }));
};